import axios from "axios";
import label from "@/lang/StaticLabels.js";
import alert from "@/lang/AlertMessages.js";
const slryUrl = "Hrms/api/v1/slry/";

export default {
  // AccountConfig Actions ------------------------------------------------------------------
  getAccountConfig({ dispatch, commit }) {
    axios
      .get(slryUrl + "basic/AccountConfig")
      .then((res) => {
        commit("setAccountConfig", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addAccountConfig({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/AccountConfig", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editAccountConfig({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/AccountConfig/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteAccountConfig({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/AccountConfig/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // tax table  actions -----------------------------------------------------
  getTaxTable({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "basic/tax?" + data)
      .then((res) => {
        commit("setTaxTable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getTaxTableById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/tax/" + data)
      .then((res) => {
        commit("setTaxTableById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addTaxTable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/Tax", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editTaxTable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/Tax/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteTaxTable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/tax", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getTaxTableIsValid({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/tax/IsValidTax?" + data)
      .then((res) => {
        commit("setTaxTableIsValid", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTaxTableLastRecord({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/tax/GetLastRecord?" + data)
      .then((res) => {
        commit("setTaxTableLastRecord", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // occupation category actions --------------------------------
  getOccupationCategory({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "basic/OccupationCategory")
      .then((res) => {
        commit("setOccupationCategory", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getOccupationCategoryById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/OccupationCategory/" + data)
      .then((res) => {
        commit("setOccupationCategoryById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getOccupationCategoryCode({ dispatch, commit }) {
    axios
      .get(slryUrl + "basic/OccupationCategory/MaxCode")
      .then((res) => {
        commit("setOccupationCategoryCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addOccupationCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/OccupationCategory", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editOccupationCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/OccupationCategory/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteOccupationCategory({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/OccupationCategory", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Nationality Type actions --------------------------------
  getNationalityType({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "basic/NationalityType")
      .then((res) => {
        commit("setNationalityType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getNationalityTypeById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/NationalityType/" + data)
      .then((res) => {
        commit("setNationalityTypeById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getNationalityTypeCode({ dispatch, commit }) {
    axios
      .get(slryUrl + "basic/NationalityType/MaxCode")
      .then((res) => {
        commit("setNationalityTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addNationalityType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/NationalityType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editNationalityType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/NationalityType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteNationalityType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/NationalityType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Work Place Status actions --------------------------------
  getWorkPlaceStatus({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "basic/WorkPlaceStatus")
      .then((res) => {
        commit("setWorkPlaceStatus", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getWorkPlaceStatusById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/WorkPlaceStatus/" + data)
      .then((res) => {
        commit("setWorkPlaceStatusById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getWorkPlaceStatusCode({ dispatch, commit }) {
    axios
      .get(slryUrl + "basic/WorkPlaceStatus/MaxCode")
      .then((res) => {
        commit("setWorkPlaceStatusCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addWorkPlaceStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/WorkPlaceStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editWorkPlaceStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/WorkPlaceStatus/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteWorkPlaceStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/WorkPlaceStatus", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Exemption Type actions --------------------------------
  getExemptionType({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "basic/ExemptionType")
      .then((res) => {
        commit("setExemptionType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getExemptionTypeById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/ExemptionType/" + data)
      .then((res) => {
        commit("setExemptionTypeById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getExemptionTypeCode({ dispatch, commit }) {
    axios
      .get(slryUrl + "basic/ExemptionType/MaxCode")
      .then((res) => {
        commit("setExemptionTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addExemptionType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/ExemptionType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editExemptionType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/ExemptionType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteExemptionType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/ExemptionType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // sample excel files ---------------------------------------------
  getExcelSample({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(slryUrl + "basic/ExcelSample")
      .then((res) => {
        commit("setExcelSample", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getExcelSampleById({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(slryUrl + "basic/ExcelSample/" + data)
      .then((res) => {
        commit("setExcelSampleById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getExcelSampleDetail({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/ExcelSample/" + data)
      .then((res) => {
        commit("setExcelSampleDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addExcelSample({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/ExcelSample", data)
      .then((res) => {
        commit("setExcelSampleId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteExcelSample({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/ExcelSample", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editExcelSample({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/ExcelSample/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getExcelSampleMaxColumnIndex({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/ExcelSample/MaxColumnIndex/" + data)
      .then((res) => {
        commit("setExcelSampleMaxColumnIndex", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addExcelSampleDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/ExcelSample/AddDetail", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editExcelSampleDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        slryUrl + "basic/ExcelSample/UpdateListDetail/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteExcelSampleDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/ExcelSample/DeleteDetail", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  importExcelSample({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/ExcelSample/ImportFromExcel", data)
      .then((res) => {
        if (res.status === 200) {
          commit("setExcelSampleData", res.data.data);
        }
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: res.data.message,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addDetailFromExcel({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/ExcelSample/AddDetailFromExcel", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Benefits And Deduction -----------------------------------------------------
  getBenefitsAndDeduction({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "basic/BenefitsAndDeduction")
      .then((res) => {
        commit("setBenefitsAndDeduction", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBenefitsAndDeductionById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/BenefitsAndDeduction/" + data)
      .then((res) => {
        commit("setBenefitsAndDeductionById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBenefitsAndDeductionCode({ dispatch, commit }) {
    axios
      .get(slryUrl + "basic/BenefitsAndDeduction/MaxCode")
      .then((res) => {
        commit("setBenefitsAndDeductionCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBenefitsAndDeductionPriority({ dispatch, commit }) {
    axios
      .get(slryUrl + "basic/BenefitsAndDeduction/MaxPriority")
      .then((res) => {
        commit("setBenefitsAndDeductionPriority", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addBenefitsAndDeduction({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/BenefitsAndDeduction", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBenefitsAndDeduction({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/BenefitsAndDeduction", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBenefitsAndDeduction({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/BenefitsAndDeduction/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Insurance Workplace actions --------------------------------
  getInsuranceWorkplace({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "basic/InsuranceWorkplace")
      .then((res) => {
        commit("setInsuranceWorkplace", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getInsuranceWorkplaceById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/InsuranceWorkplace/" + data)
      .then((res) => {
        commit("setInsuranceWorkplaceById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getInsuranceWorkplaceCode({ dispatch, commit }) {
    axios
      .get(slryUrl + "basic/InsuranceWorkplace/MaxCode")
      .then((res) => {
        commit("setInsuranceWorkplaceCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addInsuranceWorkplace({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/InsuranceWorkplace", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editInsuranceWorkplace({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/InsuranceWorkplace/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteInsuranceWorkplace({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/InsuranceWorkplace", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // EmployeePortalAccess Actions ------------------------------------------------------------------
  getEmployeePortalAccess({ dispatch, commit }, personId) {
    commit("setEmployeePortalAccess", null);
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .get(slryUrl + "operation/EmployeePortalAccess/GetBy?personId=" + personId)
      .then((res) => {
        commit("setEmployeePortalAccess", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  editEmployeePortalAccess({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "operation/EmployeePortalAccess/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Setting Actions ------------------------------------------------------------------
  getSettings({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "basic/Setting")
      .then((res) => {
        commit("setSettings", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  editSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/Setting/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // WorkingHours  actions -----------------------------------------------------
  getWorkingHours({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "basic/WorkingHours?" + data)
      .then((res) => {
        commit("setWorkingHours", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getWorkingHourById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/WorkingHours/" + data)
      .then((res) => {
        commit("setWorkingHourById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addWorkingHour({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/WorkingHours", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editWorkingHour({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/WorkingHours/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteWorkingHours({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/WorkingHours", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editWorkingHourOffDays({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/WorkingHours/UpdateOffDays/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // AgreementRow actions -----------------------------------------------------
  getAgreementRows({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "basic/AgreementRow")
      .then((res) => {
        commit("setAgreementRows", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getAgreementRowById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/AgreementRow/" + data)
      .then((res) => {
        commit("setAgreementRowById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addAgreementRow({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/AgreementRow", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editAgreementRow({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/AgreementRow/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteAgreementRow({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/AgreementRow", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getAgreementRowCode({ dispatch, commit }) {
    axios
      .get(slryUrl + "basic/AgreementRow/MaxCode")
      .then((res) => {
        commit("setAgreementRowCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // JobGroup actions -----------------------------------------------------
  getJobGroups({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "basic/JobGroup")
      .then((res) => {
        commit("setJobGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getJobGroupById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/JobGroup/" + data)
      .then((res) => {
        commit("setJobGroupById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addJobGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/JobGroup", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editJobGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/JobGroup/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteJobGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/JobGroup", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getJobGroupCode({ dispatch, commit }) {
    axios
      .get(slryUrl + "basic/JobGroup/MaxCode")
      .then((res) => {
        commit("setJobGroupCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // ContractType actions -----------------------------------------------------
  getContractTypes({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "basic/ContractType")
      .then((res) => {
        commit("setContractTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getContractTypeById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/ContractType/" + data)
      .then((res) => {
        commit("setContractTypeById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addContractType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/ContractType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editContractType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/ContractType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteContractType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/ContractType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getContractTypeCode({ dispatch, commit }) {
    axios
      .get(slryUrl + "basic/ContractType/MaxCode")
      .then((res) => {
        commit("setContractTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // AdditionalContractParameter actions -----------------------------------------------------
  getAdditionalContractParameters({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "basic/AdditionalContractParameter")
      .then((res) => {
        commit("setAdditionalContractParameters", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addAdditionalContractParameter({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/AdditionalContractParameter", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // ParameterValue Actions ------------------------------------------------------------------
  getParameterValues({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/ParameterValue/" + data)
      .then((res) => {
        commit("setParameterValues", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addParameterValue({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/ParameterValue", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editParameterValue({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/ParameterValue/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteParameterValue({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/ParameterValue/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // ContractSample Actions ------------------------------------------------------------------
  getContractSamples({ dispatch, commit }) {
    axios
      .get(slryUrl + "operation/ContractSample")
      .then((res) => {
        commit("setContractSamples", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getContractSampleById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/ContractSample/" + data)
      .then((res) => {
        commit("setContractSampleById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addContractSample({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/ContractSample", data)
      .then((res) => {
        commit("setContractSampleId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editContractSample({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "operation/ContractSample/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteContractSample({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "operation/ContractSample", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getContractSampleNavigation({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/ContractSample/Navigation?" + data)
      .then((res) => {
        commit("setContractSampleNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getContractSampleCode({ dispatch, commit }) {
    axios
      .get(slryUrl + "operation/ContractSample/MaxCode")
      .then((res) => {
        commit("setContractSampleCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  copyContractSample({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/ContractSample/Copy", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Contract Actions ------------------------------------------------------------------
  getContracts({ dispatch, commit }) {
    axios
      .get(slryUrl + "operation/Contract")
      .then((res) => {
        commit("setContracts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getContractById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/Contract/" + data)
      .then((res) => {
        commit("setContractById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addContract({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/Contract", data)
      .then((res) => {
        commit("setContractId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editContract({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "operation/Contract/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editGroupContract({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "operation/Contract/GroupUpdate", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteContract({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "operation/Contract", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getContractCode({ dispatch, commit }) {
    axios
      .get(slryUrl + "operation/Contract/MaxCode")
      .then((res) => {
        commit("setContractCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  copyContract({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/Contract/Copy", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  copyContractRangeDate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/Contract/CopyRangeDate", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getContractNavigation({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/Contract/Navigation?" + data)
      .then((res) => {
        commit("setContractNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Formula Actions ------------------------------------------------------------------
  getFormulas({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/Formula" + data)
      .then((res) => {
        commit("setFormulas", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFormulaById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/Formula/" + data)
      .then((res) => {
        commit("setFormulaById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addFormula({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/Formula", data)
      .then((res) => {
        commit("setFormulaId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editFormula({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/Formula/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteFormula({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/Formula", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getFormulaCode({ dispatch, commit }) {
    axios
      .get(slryUrl + "basic/Formula/MaxCode")
      .then((res) => {
        commit("setFormulaCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFormulaPriority({ dispatch, commit }) {
    axios
      .get(slryUrl + "basic/Formula/MaxPriority")
      .then((res) => {
        commit("setFormulaPriority", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // PayrollEmployee actions --------------------------------
  getPayrollEmployees({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .get(slryUrl + "operation/PayrollEmployee?" + data)
      .then((res) => {
        commit("setPayrollEmployees", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPayrollEmployee({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "operation/PayrollEmployee/" + data)
      .then((res) => {
        commit("setPayrollEmployee", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addPayrollEmployee({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/PayrollEmployee", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPayrollEmployee({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "operation/PayrollEmployee", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPayrollEmployeeSync({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(slryUrl + "operation/PayrollEmployee/Sync", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePayrollEmployee({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "operation/PayrollEmployee", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPayrollEmployeeContracts({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .get(slryUrl + "operation/PayrollEmployee/Contracts?" + data)
      .then((res) => {
        commit("setPayrollEmployeeContracts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintPayrollEmployee({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(slryUrl + "operation/PayrollEmployee/Print/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPayrollEmployeeVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(slryUrl + "operation/PayrollEmployee/Voucher?" + data)
      .then((res) => {
        commit("setPayrollEmployeeVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addPayrollEmployeeVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/PayrollEmployee/Voucher", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePayrollEmployeeVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "operation/PayrollEmployee/Voucher", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPayrollEmployeePayment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(slryUrl + "operation/PayrollEmployee/Payment?" + data)
      .then((res) => {
        commit("setPayrollEmployeePayment", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addPayrollEmployeePayment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/PayrollEmployee/Payment", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePayrollEmployeePayment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "operation/PayrollEmployee/Payment", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  changePayrollEmployeeConfirm({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios

      .put(slryUrl + "operation/PayrollEmployee/ChangeConfirm", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPayrollEmployeeDirectVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(slryUrl + "operation/PayrollEmployee/DirectVoucher?" + data)
      .then((res) => {
        commit("setPayrollEmployeeDirectVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addPayrollEmployeeDirectVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/PayrollEmployee/DirectVoucher", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePayrollEmployeeDirectVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "operation/PayrollEmployee/DirectVoucher", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  payrollEmployeeSendSms({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/PayrollEmployee/SendSms", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPayrollEmployeeCalculate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/PayrollEmployee/Calculate", data)
      .then((res) => {
        commit("setPayrollEmployeeCalculate", res.data.data);
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPayrollEmployeeNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(slryUrl + "operation/PayrollEmployee/Navigation?" + data)
      .then((res) => {
        commit("setPayrollEmployeeNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  importExcelPreviewPayrollEmployee({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setPayrollEmployeeImportPreview", null);
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/PayrollEmployee/ImportFromExcelPreview", data)
      .then((res) => {
        commit("setPayrollEmployeeImportPreview", res.data.data || null);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  importExcelPayrollEmployee({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/PayrollEmployee/ImportFromExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          commit("setPayrollEmployeeImportPreview", null);
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: res.data.message,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // TaxRateType actions --------------------------------
  getTaxRateTypes({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "basic/TaxRateType")
      .then((res) => {
        commit("setTaxRateTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  editTaxRateType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/TaxRateType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Report actions --------------------------------
  getPayrollEmployeeReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "report/Report/PayrollEmployee?" + data)
      .then((res) => {
        commit("setPayrollEmployeeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getEmployeePayrollSummaryPersonnelReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "report/Report/EmployeePayrollSummaryPersonnel?" + data)
      .then((res) => {
        commit("setEmployeePayrollSummaryPersonnelReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getEmployeePayrollSummaryPersonnelDetail({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        slryUrl + "report/Report/EmployeePayrollSummaryPersonnelDetail?" + data,
      )
      .then((res) => {
        commit("setEmployeePayrollSummaryPersonnelDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPayrollEmployeeSummaryReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "report/Report/PayrollEmployeeSummary?" + data)
      .then((res) => {
        commit("setPayrollEmployeeSummaryReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPayrollEmployeeSummaryInsuranceWorkplaceReport(
    { dispatch, commit },
    data,
  ) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        slryUrl +
          "report/Report/PayrollEmployeeSummaryInsuranceWorkplace?" +
          data,
      )
      .then((res) => {
        commit(
          "setPayrollEmployeeSummaryInsuranceWorkplaceReport",
          res.data.data,
        );
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getAdvanceReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "report/Report/Advance?" + data)
      .then((res) => {
        commit("setAdvanceReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPayslipReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "report/Report/Payslip?" + data)
      .then((res) => {
        commit("setPayslipReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // InsuranceEmployee Actions ------------------------------------------------------------------
  getInsuranceEmployees({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/InsuranceEmployee?" + data)
      .then((res) => {
        commit("setInsuranceEmployees", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getInsuranceEmployee({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/InsuranceEmployee/" + data)
      .then((res) => {
        commit("setInsuranceEmployee", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addInsuranceEmployee({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/InsuranceEmployee", data)
      .then((res) => {
        commit("setInsuranceEmployeeId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editInsuranceEmployee({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "operation/InsuranceEmployee/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteInsuranceEmployee({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "operation/InsuranceEmployee", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getInsuranceEmployeeContracts({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(slryUrl + "operation/InsuranceEmployee/Contracts?" + data)
      .then((res) => {
        commit("setInsuranceEmployeeContracts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addInsuranceEmployeeContracts({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/InsuranceEmployee/FromContracts", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getInsuranceEmployeeNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(slryUrl + "operation/InsuranceEmployee/Navigation?" + data)
      .then((res) => {
        commit("setInsuranceEmployeeNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addInsuranceEmployeeCopy({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/InsuranceEmployee/Copy", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getInsuranceEmployeeInsuranceDisk({ commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/InsuranceEmployee/InsuranceDisk", data, {
        responseType: "blob",
      })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: res.headers["content-type"],
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const disposition = res.headers["content-disposition"];
        let fileName = "InsuranceDisk.zip";
        if (disposition) {
          const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/);
          if (match) {
            fileName = decodeURIComponent(match[1].replace(/"/g, ""));
          }
        }
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  printInsuranceEmployee({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(
        slryUrl + "operation/InsuranceEmployee/Print/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // TaxEmployee Actions ------------------------------------------------------------------
  getTaxEmployees({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/TaxEmployee?" + data)
      .then((res) => {
        commit("setTaxEmployees", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTaxEmployee({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/TaxEmployee/" + data)
      .then((res) => {
        commit("setTaxEmployee", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addTaxEmployee({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/TaxEmployee", data)
      .then((res) => {
        commit("setTaxEmployeeId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editTaxEmployee({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "operation/TaxEmployee/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteTaxEmployee({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "operation/TaxEmployee", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getTaxEmployeeContracts({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(slryUrl + "operation/TaxEmployee/Contracts?" + data)
      .then((res) => {
        commit("setTaxEmployeeContracts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addTaxEmployeeContracts({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/TaxEmployee/FromContracts", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getTaxEmployeeNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(slryUrl + "operation/TaxEmployee/Navigation?" + data)
      .then((res) => {
        commit("setTaxEmployeeNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getTaxEmployeeTaxFile({ commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/TaxEmployee/TaxFile", data, {
        responseType: "blob",
      })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: res.headers["content-type"],
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const disposition = res.headers["content-disposition"];
        let fileName = "TaxFile.zip";
        if (disposition) {
          const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/);
          if (match) {
            fileName = decodeURIComponent(match[1].replace(/"/g, ""));
          }
        }
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  printTaxEmployee({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/TaxEmployee/Print/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Leave Actions ------------------------------------------------------------------
  getLeaves({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/Leave" + (data ?? ""))
      .then((res) => {
        commit("setLeaves", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getLeaveById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/Leave/" + data)
      .then((res) => {
        commit("setLeaveById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addLeave({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/Leave", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editLeave({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "operation/Leave/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteLeave({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "operation/Leave", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  changeLeaveConfirm({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "operation/Leave/ChangeConfirm", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getLeaveCode({ dispatch, commit }) {
    axios
      .get(slryUrl + "operation/Leave/MaxCode")
      .then((res) => {
        commit("setLeaveCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getLeaveNavigation({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/Leave/Navigation?" + data)
      .then((res) => {
        commit("setLeaveNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getLeaveManagementCartable({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "operation/Leave/LeaveManagementCartableList?" + data)
      .then((res) => {
        commit("setLeaveManagementCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  leaveManagementCartableAction({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(slryUrl + "operation/Leave/ManagementCartable", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getLeaveConfirm({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "operation/Leave/GetCartable?" + data)
      .then((res) => {
        commit("setLeaveConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  leaveChangeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/Leave/ChangeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Mission Actions ------------------------------------------------------------------
  getMissions({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/Mission" + (data ?? ""))
      .then((res) => {
        commit("setMissions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMissionById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/Mission/" + data)
      .then((res) => {
        commit("setMissionById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addMission({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/Mission", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editMission({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "operation/Mission/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteMission({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "operation/Mission", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  changeMissionConfirm({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "operation/Mission/ChangeConfirm", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getMissionCode({ dispatch, commit }) {
    axios
      .get(slryUrl + "operation/Mission/MaxCode")
      .then((res) => {
        commit("setMissionCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMissionNavigation({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/Mission/Navigation?" + data)
      .then((res) => {
        commit("setMissionNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMissionManagementCartable({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "operation/Mission/MissionManagementCartableList?" + data)
      .then((res) => {
        commit("setMissionManagementCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  missionManagementCartableAction({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(slryUrl + "operation/Mission/ManagementCartable", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getMissionConfirm({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "operation/Mission/GetCartable?" + data)
      .then((res) => {
        commit("setMissionConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  missionChangeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/Mission/ChangeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Advance Actions  ------------------------------------------------------------------
  getAdvances({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/Advance" + (data ?? ""))
      .then((res) => {
        commit("setAdvances", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAdvanceById({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/Advance/" + data)
      .then((res) => {
        commit("setAdvanceById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addAdvance({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/Advance", data)
      .then((res) => {
        commit("setAdvanceId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  updateGroupAdvance({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "operation/Advance/UpdateGroup", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteAdvance({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "operation/Advance", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getAdvanceCode({ dispatch, commit }) {
    axios
      .get(slryUrl + "operation/Advance/MaxCode")
      .then((res) => {
        commit("setAdvanceCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAdvanceNavigation({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/Advance/Navigation?" + data)
      .then((res) => {
        commit("setAdvanceNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getAdvanceManagementCartable({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "operation/Advance/AdvanceManagementCartableList?" + data)
      .then((res) => {
        commit("setAdvanceManagementCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCartableLog({ dispatch, commit }, data) {
    axios
      .get("Hrms/api/v1/operation/CartableLog?" + data)
      .then((res) => {
        commit("setCartableLog", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  advanceManagementCartableAction({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(slryUrl + "operation/Advance/ManagementCartable", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getAdvanceConfirm({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "operation/Advance/GetCartable?" + data)
      .then((res) => {
        commit("setAdvanceConfirm", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  advanceChangeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/Advance/ChangeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getAdvanceVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(slryUrl + "operation/Advance/Voucher?ids=" + data)
      .then((res) => {
        commit("setAdvanceVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addAdvanceVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/Advance/Voucher", data)
      .then((res) => {
        // شماره و شناسه سند صادرشده تا فرم بدون واکشی مجدد به‌روز شود
        const issued = res.data.data?.[0] ?? {};
        commit("setAdvanceVoucherId", issued.voucherId ?? null);
        commit("setAdvanceVoucherNumber", issued.voucherNumber ?? null);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteAdvanceVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "operation/Advance/Voucher", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  printAdvance({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "operation/Advance/Print/" + data.id, data.value)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // BankExportTemplate Actions -----------------------------------------------
  getBankExportTemplates({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "basic/BankExportTemplate?" + (data || ""))
      .then((res) => {
        commit("setBankExportTemplates", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBankExportTemplateById({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "basic/BankExportTemplate/" + data)
      .then((res) => {
        commit("setBankExportTemplateById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBankExportTemplateCode({ dispatch, commit }) {
    axios
      .get(slryUrl + "basic/BankExportTemplate/MaxCode")
      .then((res) => {
        commit("setBankExportTemplateCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBankExportVariables({ dispatch, commit }) {
    axios
      .get(slryUrl + "basic/BankExportTemplate/Variables")
      .then((res) => {
        commit("setBankExportVariables", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addBankExportTemplate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/BankExportTemplate", data)
      .then((res) => {
        commit("setBankExportTemplateId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // ویرایش، جایگزینی کامل درخت است نه patch؛ همیشه کل ساختار ارسال می‌شود و
  // بعد از ذخیره باید قالب دوباره خوانده شود چون شناسه فیلدها عوض می‌شود.
  editBankExportTemplate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/BankExportTemplate/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  cloneBankExportTemplate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/BankExportTemplate/Clone", data)
      .then((res) => {
        commit("setBankExportTemplateId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // فعال/غیرفعال کردن قالب اندپوینت اختصاصی ندارد؛ چون ویرایش جایگزینی کامل
  // است، ابتدا کل درخت خوانده و سپس با isActive معکوس دوباره ارسال می‌شود.
  toggleBankExportTemplateActive({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(slryUrl + "basic/BankExportTemplate/" + data)
      .then((res) => {
        const template = res.data.data;
        template.isActive = !template.isActive;
        return axios
          .put(slryUrl + "basic/BankExportTemplate/" + data, template)
          .then((putRes) => {
            dispatch(
              "successPOSTHandler",
              {
                server: putRes,
                message: putRes.data.message,
                redirect: false,
              },
              { root: true },
            );
          });
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBankExportTemplate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    commit("setBankExportTemplateDeleteError", null);
    axios
      .delete(slryUrl + "basic/BankExportTemplate", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        // قالبی که با آن فایل صادر شده حذف نمی‌شود؛ پیام سرور را نگه می‌داریم
        // تا صفحه بتواند گزینه «غیرفعال کردن» را پیشنهاد دهد.
        const message =
          error && error.response && error.response.data
            ? error.response.data.message
            : null;
        commit("setBankExportTemplateDeleteError", message || null);
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // BankExport Actions -------------------------------------------------------
  getBankExportPayrolls({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/Payroll?" + (data || ""))
      .then((res) => {
        commit("setBankExportPayrolls", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBankExportPreview({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    commit("setBankExportError", null);
    axios
      .post(slryUrl + "operation/BankExport/Preview", data)
      .then((res) => {
        commit("setBankExportPreview", res.data.data || {});
      })
      .catch((error) => {
        commit("setBankExportPreview", {});
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 500);
      });
  },

  // این اندپوینت ApiResult برنمی‌گرداند: یا فایل باینری است یا BadRequest.
  // در حالت خطا بدنه blob به متن تبدیل و پیام چندخطی در state ذخیره می‌شود.
  exportBankFile({ commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    commit("setBankExportError", null);
    return axios
      .post(slryUrl + "operation/BankExport/Export", data, {
        responseType: "blob",
      })
      .then((res) => {
        // نوع فایل و نام آن از خود پاسخ خوانده می‌شود؛ اکسل، متنی و CSV
        // همگی با همین مسیر عمومی دانلود می‌شوند.
        const contentType = res.headers["content-type"] || "";
        const blob = new Blob([res.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const disposition = res.headers["content-disposition"];
        let fileName = "";
        if (disposition) {
          const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/);
          if (match) {
            fileName = decodeURIComponent(match[1].replace(/"/g, ""));
          }
        }
        if (!fileName) {
          // اگر سرور نام فایل نفرستاد، پسوند از نوع محتوای همان پاسخ ساخته می‌شود
          const extensionOf = {
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
              "xlsx",
            "application/vnd.ms-excel": "xls",
            "text/csv": "csv",
            "application/xml": "xml",
            "text/xml": "xml",
          };
          const mime = contentType.split(";")[0].trim().toLowerCase();
          fileName = "BankExport." + (extensionOf[mime] || "txt");
        }
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        commit("setSuccess", alert.success.save, { root: true });
      })
      .catch((error) => {
        const body = error && error.response ? error.response.data : null;
        if (body instanceof Blob) {
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
              let message = reader.result;
              try {
                const parsed = JSON.parse(message);
                message = parsed.message || message;
              } catch (e) {
                // بدنه خطا متن ساده چندخطی است، نه JSON
              }
              commit("setBankExportError", message || null);
              resolve();
            };
            reader.onerror = () => {
              resolve();
            };
            reader.readAsText(body);
          });
        }
        commit("setBankExportError", (body && body.message) || null);
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 500);
      });
  },

  getBankExportHistory({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/BankExport/History?" + (data || ""))
      .then((res) => {
        commit("setBankExportHistory", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBankExportHistoryDetail({ dispatch, commit }, data) {
    axios
      .get(slryUrl + "operation/BankExport/HistoryDetail/" + data)
      .then((res) => {
        commit("setBankExportHistoryDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Payroll actions --------------------------------
  getPayroll({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "operation/Payroll?" + data)
      .then((res) => {
        commit("setPayroll", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  editPayroll({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "operation/Payroll/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Service actions --------------------------------
  getServices({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(slryUrl + "basic/Service")
      .then((res) => {
        commit("setServices", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addService({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(slryUrl + "basic/Service", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editService({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(slryUrl + "basic/Service/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteService({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(slryUrl + "basic/Service", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
};
